import { ActiveOrganization } from "@/api";
import { Settings } from "../../../components/ui/SettingsSection";
import { CustomerAccount } from "./CustomerAccountConnection/CustomerAccountConnection";
import { PaymentPlatformConnection } from "./PaymentPlatformConnection/PaymentPlatformConnection";

interface Props {
  organization: ActiveOrganization;
}

export const Subscriptions = ({ organization }: Props) => {
  return (
    <Settings.Section title="Subscriptions">
      <Settings.Item
        title="Customer account"
        description="A payment method is required for you (or your organization) to subscribe to paid app subscriptions."
      >
        <CustomerAccount organization={organization} />
      </Settings.Item>

      <Settings.Item
        title="Revenue connection"
        description="Account information is required for you (or your organization) to receive payment from your paid subscriptions."
      >
        <PaymentPlatformConnection organization={organization} />
      </Settings.Item>
    </Settings.Section>
  );
};
